.outline {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}

.field {
  --outline-radius: var(--mantine-radius-xl);
  opacity: 0;
  transition: opacity 240ms ease;
}

:focus-within > .field {
  opacity: 1;
}

.sidebar {
  --outline-radius: var(--ai-radius, var(--mantine-radius-md));
  --trail-blur: 2px;
  --trail-width: 8px;
}

.path {
  x: 1.25px;
  y: 1.25px;
  width: calc(100% - 2.5px);
  height: calc(100% - 2.5px);
  rx: calc(var(--outline-radius) - 2px);
}

.trail {
  stroke-width: var(--trail-width, 40px);
  filter: blur(var(--trail-blur, 11px));
}

@media (prefers-reduced-motion: no-preference) {
  .trail {
    animation: trace 5s linear infinite paused;
  }

  :focus-within > .field .trail,
  .sidebar .trail {
    animation-play-state: running;
  }
}

@keyframes trace {
  to {
    stroke-dashoffset: -100;
  }
}

@media (prefers-reduced-motion: reduce) {
  .field {
    transition: none;
  }
}
